define('datakit/mixin/virtual.attributes.mixin',['require','exports','module','underscore','backbone','create-error'],function(require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var createError = require('create-error');
  var CircularCallError = createError('CircularCallError');

  var GET_REGEX = /get\(['"]([^'"]+)['"]\)/g

  var VirtualAttributesMixin = {

    CircularCallError: CircularCallError,

    virtual: {},

    detectVirtualDependencies: false,

    initializeMixin: function(attributes, options) {
      options = options || {};

      if (_.has(options, 'detectVirtualDependencies')) {
        this.detectVirtualDependencies = options.detectVirtualDependencies;
      }

      var virtual = this.virtual;

      this.virtual = {};
      this._virtualStackCounter = {};

      _.each(virtual, function(definition, virtualKey) {
        this._createVirtual(virtualKey, definition);
      }, this);

    },

    _createVirtual: function(virtualKey, definition) {
      this._virtualStackCounter[virtualKey] = 0;

      definition = this._normalizeVirtualDefinition(definition);

      // we cannot create a virtual that does not have a getter
      if (!_.isFunction(definition.get)) { return; }

      this._initializeEventsForVirtualDependencies(virtualKey, definition.deps)

      this.virtual[virtualKey] = definition;
      this.registerSetter(virtualKey, function() {});
      this.registerGetter(virtualKey, this.getVirtual);
    },

    _normalizeVirtualDefinition: function(definition) {
      var key, canDetectVirtualDependencies = false;

      if (_.isFunction(definition)) {
        canDetectVirtualDependencies = true;
        definition = {
          deps: [],
          get: definition
        };
      } else if (_.isString(definition)) {
        key = definition;
        definition = {
          deps: [key],
          get: function() { return this.get(key); }
        };
      }

      if (canDetectVirtualDependencies && this.detectVirtualDependencies){
        definition.deps = definition.deps.concat(this._findVirtualDependencies(definition.get));
      }

      return definition
    },

    getVirtual: function(attr) {
      if (this._virtualStackCounter[attr] > 0) {
        throw new CircularCallError('Called virtual property "' + attr + '" more than once in the same get');
      }
      this._virtualStackCounter[attr]++;
      var ret = this.virtual[attr].get.call(this, attr);
      this._virtualStackCounter[attr]--;
      return ret;
    },

    _findVirtualDependencies: function(getter) {
      var deps = [];
      if (!_.isFunction(getter))  { return deps; }
      var match, functionStr = getter.toString();
      while(match = GET_REGEX.exec(functionStr)) {
        deps.push(match[1]);
      }
      return deps;
    },

    _initializeEventsForVirtualDependencies: function(virtualKey, deps) {
      var events = _.map(deps, function(attr) {
        // make sure we don't get into an event loop
        if (attr == virtualKey) { return ''; }
        return 'change:' + attr;
      }).join(' ');
      this.on(events, function(model, value, options) {
        this.trigger('change:' + virtualKey, this, this.get(virtualKey), options);
      }, this);
    }

  };
  module.exports = VirtualAttributesMixin;
});

